
export const argo = "Argo";
export const cams = "CAMS / Copernicus / European Commission + ECMWF";
export const cpc = "CPC / NCEP / US National Weather Service";
export const crw = "Coral Reef Watch / NOAA";
export const firms = "VIIRS NRT / FIRMS / EOSDIS / NASA";
export const geos = "GEOS-5 / GMAO / NASA";
export const gfs = "GFS / NCEP / US National Weather Service";
export const hrrr = "HRRR / NCEP / US National Weather Service";
export const oscar = "OSCAR / Earth & Space Research";
export const ostia = "OSTIA / UK Met Office + GHRSST + CMEMS";
export const ovation = "OVATION / SWPC / NCEP / NWS / NOAA";
export const rtgsst = "RTG-SST / NCEP / US National Weather Service";
export const ww3 = "WAVEWATCH III / NCEP / NWS";
